// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"NotesForm_cardHeader__mczev","hr":"NotesForm_hr__mm_UJ","textAreaLabel":"NotesForm_textAreaLabel__TITz0","textArea":"NotesForm_textArea__2XKBD"};